export default __webpack_public_path__ + "static/media/image13.8ca329e1.png";